import React, {useEffect, useState, useRef} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {getLanguage, t} from 'react-switch-lang';
import {getAllCourtCategoryRisks} from '../../../services/CourtCategoryRisks/courtCategoryRisks';
import {
  getAllCourtSubcategoryRisks,
  createCourtSubcategoryRisk,
  deleteCourtSubcategoryRisk,
  updateCourtSubcategoryRisk,
} from '../../../services/CourtSubcategoryRisks/courtSubcategoryRisks';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import Swal from "sweetalert2";
import AddIcon from "../Metodologies/plus.png";

const CourtSubcategoryRisks = () => {
  const [courtSubcategoryRisks, setCourtSubcategoryRisks] = useState([]);
  const [courtCategoryRisks, setCourtCategoryRisks] = useState([]);
  const [query, setQuery] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllCourtCategoryRisks();
        setCourtCategoryRisks(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const formatedCourtCategoryRisks = courtCategoryRisks.map((d) => ({
    label: getLanguage() === "eng" ? d.nameEn : d.name,
    value: d.id,
  }));

  const columns = [
    {
      dataIndex: 'name',
      title: t('common.name'),
      editable: true,
      placeholder:`${t('common.placeholder.name')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('common.nameEn'),
      editable: true,
      placeholder: `${t('common.placeholder.nameEn')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'courtCategoryRiskId', // Nested properties
      nestedKey: getLanguage() === "eng" ? 'nameEn' : 'name',
      title: t('courtCategoryRisks.courtCategoryRisk'),
      editable: true,
      inputType: 'customSelect', // InputType default vrijednost je 'text' tako da ga setujemo samo ukoliko nam nesto drugo treba
      options: formatedCourtCategoryRisks,
      render: (value) => {
        const courtCategoryRisk = formatedCourtCategoryRisks?.find((d) => d.value === value);
        return courtCategoryRisk?.label;
      },
      rules: [
        {required: true, message: t('message.fieldRequired')},
      ],
      // S tim da dataIndex gadja id, ime departmenta moramo manualno preko redner propa prikazati
      // Render prop prima vrijednost polja kao parametar
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.id = editingRecord.id;
    try {
      const response = await updateCourtSubcategoryRisk(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess3', {entity: t('courtSubcategoryRisks.courtSubcategoryRisk')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('courtSubcategoryRisks.courtSubcategoryRiskExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('courtSubcategoryRisks.courtSubcategoryRiskExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createCourtSubcategoryRisk(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('message.addSuccess3', {entity: t('courtSubcategoryRisks.courtSubcategoryRisk')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('courtSubcategoryRisks.courtSubcategoryRiskExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('courtSubcategoryRisks.courtSubcategoryRiskExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('courtSubcategoryRisks.courtSubcategoryRisk'), 
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete2').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deleteCourtSubcategoryRisk(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess3', {entity: t('courtSubcategoryRisks.courtSubcategoryRisk')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('message.deleteFailed', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const addButton = useRef();

  return (
    <div className="court-subcategory-risks administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('courtSubcategoryRisks.searchCourtSubcategoryRisks')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('courtSubcategoryRisks.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/court-subcategory-risks"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default CourtSubcategoryRisks;